import DispensaryStackPage from "~/components/_/u/_/stack.vue";

new Vue({
    el: "#pages-search-dispensary-stack-content",
    components: { DispensaryStackPage }
});
